module.exports = __webpack_public_path__ + "static/media/icon1.9e25e618.svg";